export default __webpack_public_path__ + "static/media/updateCOD.417608c3.xlsx";